<app-form-date-v2
  [(ngModel)]="value"
  [minDate]="minDate"
  [maxDate]="maxDate"
  (calendarClosed)="stopEditing()">
</app-form-date-v2>
